import { Component, OnInit } from '@angular/core';
import { GroupsService} from "./groups.service";
import { Group } from "./group.model";
import { Router } from '@angular/router';
import { MessagesService } from "../../messages.service";

@Component({
    selector: 'app-groups',
    templateUrl: './groups.component.html',
    styleUrls: ['./groups.component.css']
})
export class GroupsComponent implements OnInit {

    public loading : boolean;
    public groups: Group[];


    constructor(private groupsService: GroupsService, private router: Router,private messagesService:MessagesService) { }

    ngOnInit() {
        this.groups = [];
        this.loadGroups();
    }



    private loadGroups(): void {
        this.loading = true;
        this.groupsService.getAllGroups().subscribe(
            data => {this.loading = false;this.groups = data},
            error => { this.loading = false;this.checkError(error,"Ha ocurrido un error al cargar los perfiles") }
        );
    }

    deleteGroup(groupId : number){
        this.loading = true;
        this.groupsService.deleteGroup(groupId).subscribe(
            data => {this.loading = false;this.loadGroups()},
            error => { this.loading = false; this.checkError(error,"Ha ocurrido un error al eliminar el perfil") }
        );    
    }

   private checkError(error: any, defaultMessage: string) {
        this.messagesService.checkError(error,defaultMessage);
    }

}

